'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('../../../common/columns/index');

var _index2 = _interopRequireDefault(_index);

var _ColumnPresentationalWrapper = require('./ColumnPresentationalWrapper');

var _ColumnPresentationalWrapper2 = _interopRequireDefault(_ColumnPresentationalWrapper);

var _ColumnContainer = require('./ColumnContainer');

var _ColumnContainer2 = _interopRequireDefault(_ColumnContainer);

var _browser = require('../../utils/services/browser');

var _toolbarConstants = require('../../workspace/toolbar/toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _index2.default)({
        presentationalComponent: _ColumnPresentationalWrapper2.default,
        containerComponent: _ColumnContainer2.default,
        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.LOCK],
        tooltip: _browser.isApple ? '⌃⌘G' : 'Ctrl+Alt+G'
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/column/index.js
// module id = 1965
// module chunks = 0